export default "__VITE_ASSET__BPJmVPRO__"